import React, { useState, useEffect } from "react";
import "./reitsCompare.less";
import ReitSelector from "./reit-selector/reitSelector";
import ReitsCharacteristics from "./characteristics-table/characteristics";
import { ReitProvider } from "../../../context/reitContext";
import REITMaps from "../../reits-map";
import service from "../../../services/service";
import { useLocation, useNavigate } from "react-router-dom";

interface MapProps {
  center?: { lat: number; lng: number };
  adjPropertiesLoc?: Array<{ lat: number; lng: number; label: string }>;
}

const ReitsCompare: React.FC = () => {
  const displayName = "cmp-reits-compare-properties";
  const [combinedData, setCombinedData] = useState<string[]>([]);
  const [mapProps, setMapProps] = useState<MapProps>({ adjPropertiesLoc: [] });
  const location = useLocation();
  const navigate = useNavigate();
  const reitId = location.state?.reitId;

  const handleReitSelection = async (selectedProperties: string[]) => {
    setCombinedData(selectedProperties);

    if (!selectedProperties.length) {
      setMapProps({ adjPropertiesLoc: [] });
      return;
    }

    try {
      const response = await service.getAdjacentByNames(selectedProperties);
      if (!response || response.length === 0) return;

      const adjPropertiesLoc = response.map((p: any) => ({
        lat: p.latlng.lat,
        lng: p.latlng.lng,
        label: p.latlng.label,
      }));

      setMapProps({
        center: { lat: adjPropertiesLoc[0].lat, lng: adjPropertiesLoc[0].lng },
        adjPropertiesLoc,
      });
    } catch (err) {
      console.error("Failed to fetch adjacent data for map:", err);
    }
  };

  useEffect(() => {
    const firstPropertyName = localStorage.getItem("FIRST_SELECTED_PROPERTY");
    if (firstPropertyName && combinedData.length === 0) {
      handleReitSelection([firstPropertyName]);
    }
  }, []);

  return (
    <div className={`${displayName}`}>
      <section className={`${displayName}__hero-banner`}>
        <button
          className={`${displayName}__back-btn`}
          onClick={() => {
            if (reitId) {
              navigate(`/reits/${reitId}`);
            } else {
              navigate(-1);
            }
          }}
          aria-label="Go Back"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
          >
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
        </button>

        <div className={`${displayName}__hero-text`}>
          <h1>
            Compare REITs <span>Properties</span>
          </h1>
          <p>
            Side-by-side REITs properties comparison to help you pick the right
            investment with ease.
          </p>
        </div>
      </section>

      <ReitProvider>
        <ReitSelector onData={handleReitSelection} />
        <ReitsCharacteristics />
        {mapProps.adjPropertiesLoc && mapProps.adjPropertiesLoc.length > 0 && (
          <div className={`${displayName}__map`}>
            <REITMaps props={mapProps} />
          </div>
        )}
      </ReitProvider>
    </div>
  );
};

export default ReitsCompare;
